module.exports = __webpack_public_path__ + "static/media/64 - Logo PPIA RMIT.89aa35c4.png";